import { Group, Text } from "@mantine/core";
import { EntityClientAction, MultiDataMapForm } from "@mcurros2/microm";
import { IconAlertCircle, IconUserPin } from "@tabler/icons-react";
import { Personal } from "./Personal";

export const ACTGestionarPersonal: EntityClientAction = {
    name: 'ACTGestionarPersonal',
    label: 'Gestionar Personal',
    title: <Text fw={700}>Gestionar Personal</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['perl_brwGestionPersonal'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Personal;
        parent.def.columns.c_superior_id.value = selectedKeys![0].c_personal_id as unknown as string || '';
        parent.parentKeys = { ...parent.parentKeys, ...{ c_superior_id: selectedKeys![0].c_personal_id } };

        const description = `Personal: ${selectedKeys![0].vc_nombre}` as string;

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">{description}</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <MultiDataMapForm
                autoFocus
                formMode="edit"
                key={`mapa-ubicacion-personal-${entity.def.name}`}
                title="Gestionar Personal"
                dataMapView1={{
                    entity: parent,
                    viewName: parent.def.views.perl_brwGestionPersonalDetalles.name,
                    parentKeys: parent.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 4, longitudRecordIndex: 5,
                    tabLabel: "Personal",
                    tabIcon: IconUserPin,
                    enableView: true,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%",
                }}

                mapHeight="50vh"
            />
        });

        return false;
    }
}